import { useState } from "react";
import { Link } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { BRAND } from "../properties";

const LINKS = [
  { label: "home", to: "/", testId: "erth-nav-home" },
  { label: "projects", to: "/#projects", testId: "erth-nav-projects" },
  { label: "experiences", to: "/#experiences", testId: "erth-nav-experiences" },
  { label: "journal", to: "/journal", testId: "erth-nav-journal" },
  { label: "contact us", to: "/#contact", testId: "erth-nav-contact" },
];

export const ErthNav = () => {
  const [open, setOpen] = useState(false);
  const close = () => setOpen(false);

  return (
    <header data-testid="erth-navbar" className="fixed inset-x-0 top-0 z-50 bg-erth-black text-erth-white">
      <div className="mx-auto flex h-[4.5rem] max-w-7xl items-center justify-between px-5 sm:px-8">
        <Link to="/" data-testid="erth-nav-logo" onClick={close} className="flex items-center">
          <img src={BRAND.logoWhite} alt="erth. escapes" className="h-9 w-auto sm:h-10" />
        </Link>

        <nav className="hidden items-center gap-10 lg:flex" aria-label="Primary">
          {LINKS.map((l) => (
            <Link
              key={l.to}
              to={l.to}
              data-testid={l.testId}
              className="link-underline font-head text-[15px] font-semibold lowercase tracking-wide transition-opacity hover:opacity-60"
            >
              {l.label}
            </Link>
          ))}
          <Link
            to="/#contact"
            data-testid="erth-nav-cta"
            className="rounded-full bg-erth-white px-7 py-3 font-head text-[14px] font-semibold lowercase text-erth-black transition-colors hover:bg-erth-beige"
          >
            enquire
          </Link>
        </nav>

        <button
          type="button"
          data-testid="erth-nav-toggle"
          aria-label={open ? "Close menu" : "Open menu"}
          onClick={() => setOpen((v) => !v)}
          className="lg:hidden"
        >
          {open ? <X size={26} /> : <Menu size={26} />}
        </button>
      </div>

      {open && (
        <nav data-testid="erth-nav-mobile" className="border-t border-erth-white/10 bg-erth-black px-5 pb-8 pt-4 lg:hidden" aria-label="Mobile">
          <ul className="flex flex-col gap-1">
            {LINKS.map((l) => (
              <li key={l.to}>
                <Link
                  to={l.to}
                  data-testid={`${l.testId}-mobile`}
                  onClick={close}
                  className="block py-3 font-head text-2xl font-semibold lowercase transition-opacity hover:opacity-60"
                >
                  {l.label}
                </Link>
              </li>
            ))}
            <li className="pt-4">
              <Link
                to="/#contact"
                data-testid="erth-nav-cta-mobile"
                onClick={close}
                className="block rounded-full bg-erth-white px-6 py-4 text-center font-head text-[14px] font-semibold lowercase text-erth-black"
              >
                enquire
              </Link>
            </li>
          </ul>
        </nav>
      )}
    </header>
  );
};
